module.exports = __webpack_public_path__ + "static/img/about-bg.2b1cdd58.png";